export interface PTO {
  pto_preprint_id  : string
  dpo_snapshot_id  : string
  dpo_theme_name   : string
  pto_design_name  : string
  pto_specialty_inks: string
  pdf_url          : string
};


// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/models/pto.model.ts